PluginButtonView = require 'views/plugin/plugin-button-view'
t = require('views/internal/teacup-with-helpers')()
track = require 'debug/track'
trackUe = require 'debug/trackUe'

template = t.renderable ({ icon, text }) ->
  if icon
    t.span '.icon-sm.plugin-icon',
      style: t.stylify
        'background-image': t.urlify "#{ icon }?color=999"
    t.raw ' '
  t.text text
  return

module.exports = class PluginCardButtonView extends PluginButtonView
  template: template
  className: 'button-link'

  trackClick: (pluginButton) ->
    track("Card Detail", "Sidebar Plugin Button", pluginButton.text)
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', pluginButton.idPlugin)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-button-view.coffee